import { post, get } from '../utils/fetch';

export default class ConfigService {
    // 获取小程序授权信息
    static getWxConfig(params) {
        return post('/relic/api/v1/common/wechatsharecfg', params)
    }

}




// WEBPACK FOOTER //
// ./src/api/configService.js